<template>
    <CustomTopSheetDialog v-model="dialogVisible" :width="1200" :title="null" :customclass="'px-4 pt-4'">
        <template #title>
            <h3 class="text-left dialog-title" color="primary">
                {{ $t('global.menu.backoffice.addBrandTo', {name: formData.name})}}
            </h3>
        </template>

        <template #default>
            <!-- build in Select Box add: show-select return-object select-strategy="multiple"  -->
            <v-data-table-server v-model:items-per-page="itemsPerPage" v-model="selectedShops" :items-per-page-options="pageOptions"
                density="compact" :headers="headers" :items="serverItems" :items-length="totalItems" :loading="loading"
                :search="searchTerm" item-value="name" @update:options="loadItems" height="50vh"
                :mobile="['xs', 'sm', 'md'].includes($globalState.screenWidth)" class="shop-list-table" fixed-header >
                <template v-slot:top>
                    <v-row>
                        <v-col>
                            <!-- TODO BACKEND SEARCH FUNCTION PAGINATION -->
                            <v-text-field v-model="search" :disabled="false" :placeholder="$t('main.search.placeholder')"
                                variant="outlined" hide-details="true" density="compact" class="pb-2 py-0 bg-white"
                                height="32px">
                                <template v-slot:append-inner>
                                    <v-icon icon="mdi-magnify"></v-icon>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="4" class="text-right">
                            
                        </v-col>
                    </v-row>
                </template>
                <!-- Checkbox for build in Select -->
                <!-- <template v-slot:[`item.data-table-select`]="props">
                    <v-checkbox density="compact" hide-details="true" v-model="props.item.brandSelected"></v-checkbox>
                </template> -->

                <template v-slot:[`item.controls`]="props">
                    <!-- {{ props.item.brandSelected }} -->
                    <v-checkbox density="compact" hide-details="true" v-model="props.item.brandSelected" @change="() => shopToBrand(props.item)"></v-checkbox>
                </template>

            </v-data-table-server>

        </template>

        <template #actions>
            <v-container class="d-flex align-items-center justify-content-end">
                <v-btn class="px-3 py-1 mr-3" variant="flat" rounded="xl" size="large" prepend-icon="mdi-content-save"
                    color="primary" @click="closeSheet">{{ $t('entity.action.close') }}</v-btn>
                <!-- <v-btn class="px-3 py-1" variant="flat" rounded="xl" size="large" prepend-icon="mdi-content-save"
                    color="primary" @click="validate">{{ $t('global.form.save') }}</v-btn> -->
            </v-container>
        </template>
    </CustomTopSheetDialog>
</template>


<script>
export default {
    name: "CreateBrandDialog",
    components: {
    },


    methods: {
    },
};
</script>
<script setup>
import { ref, inject, onMounted, computed, watch, getCurrentInstance, defineProps, defineEmits, defineModel } from 'vue';
import CustomTopSheetDialog from '@/components/custom/CustomTopSheetDialog.vue';
import LabelCategories from '../LabelCategories.vue';

const { proxy } = getCurrentInstance()
const dialogVisible = defineModel(); // Handles v-model for visibility
const formData = defineModel("data", { default: () => ({}) }); // Handles v-model for the object
const selectedLanguage = localStorage.getItem('selectedLanguage');
const form = ref(null)
const props = defineProps({
    save: Function, // Define prop as a function
});

const selectedShops = ref([ ])
const page = ref(1);
const itemsPerPage = ref(25);

const pageOptions = [
    { value: 25, title: '25' },
    { value: 50, title: '50' },
    // { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' }
];
const headers = [
    { title: 'Name', key: 'shop.name', align: 'start', maxWidth: "200px" },
    { title: 'tagline', key: 'shop.tagline', align: 'start', sortable: false },
    { title: 'Actions', value: "controls", align: 'start', sortable: false },
];
const search = ref('')
const searchTerm = computed(() => {
    return search.value.length >= 2 ? search.value : '';
});
const serverItems = ref([]);
const loading = ref(true);
const totalItems = ref(0);
const hardToken = localStorage.getItem("hardToken");
const softToken = localStorage.getItem("softToken");
const username = localStorage.getItem("username");


watch(
    () => formData.value?.nameTranslations?.DE, // Safe access using optional chaining
    (newValue) => {
        if (newValue !== undefined) {
            formData.value.name = newValue; // Update name
        }
    },
    { deep: true } // Optional: If translations can be updated dynamically
);
watch(formData, (newValue) => {
    if (!newValue) {
        formData.value = { nameTranslations: { DE: '', EN: '' } };
    }
});
watch(dialogVisible, (newValue) => {
    if (!newValue) {
        formData.value = { nameTranslations: { DE: '', EN: '' } };
        search.value = '';
    }
});

const nameRules = [
    v => !!v || 'Name is required',
    v => (v && v.length >= 3) || 'Name must be at least 3 characters',
];
const validate = async () => {
    const { valid, errors } = await form.value.validate()
    if (!valid) {
        let errorMessages = [];
        Object.values(errors).forEach(fieldErrors => {
            if (fieldErrors.errorMessages.length) {
                errorMessages.push(...fieldErrors.errorMessages);
            }
        });
        errorMessages.forEach(msg => {
            if (msg.length) {
                proxy.$toast.error(msg, { theme: "colored" });
            }
        })
         
        return;
    }
    props.save();
}

const closeSheet = () => {
    dialogVisible.value = false;
    formData.value = { nameTranslations: { DE: { value: '' }, EN: { value: '' } } };
}

const loadItems = async ({ page, itemsPerPage, sortBy }) => {
    loading.value = true
    console.log(itemsPerPage)
    try {
        const response = await proxy.$axios.get(`/backoffice/shops/brand/${formData.value.id}`,
            {
                headers: {
                    'X-Auth-HARDTOKEN': hardToken,
                    'X-Auth-SOFTTOKEN': softToken,
                    'X-Auth-USER': username
                },
                params: {
                    page: page - 1,
                    resultsPerPage: itemsPerPage,
                    name: searchTerm.value,
                    sortColumn: sortBy[0]?.key == "shop.name" ? "name" : sortBy[0]?.key,
                    sortDirection: sortBy[0]?.order.toUpperCase(),
                    search: searchTerm.value.length >= 1 ? searchTerm.value : null,
                }
            },
        );
        if (response.data.status == "OK") {
            itemsFetched(response)
        }
    } catch (error) {
        console.error("Error: ", error);
    }

};

const itemsFetched = (response) => {
    serverItems.value = response.data.data;
    totalItems.value = response.data.totalElements
    loading.value = false
}

const shopToBrand = async (item) => {
    // PUT /api/backoffice/shop/4069699f-29d4-438b-bb35-77261b00af25/brands
    const obj ={ids: [formData.value.id]}
    try {
        const response = await proxy.$axios.put(`/backoffice/shop/${item.shop.id}/brand/${item.brandSelected}`,obj,
            {
                headers: {
                    'X-Auth-HARDTOKEN': hardToken,
                    'X-Auth-SOFTTOKEN': softToken,
                    'X-Auth-USER': username
                },
            },
        );
        console.log(response)
        if(response.status == 200){
            console.log(`Successfully ${item.brandSelected ? 'added' : 'removed'} ${formData.value.name} ${item.brandSelected ? 'to' : 'from'} ${item.shop.name}.`)
            proxy.$toast.success(`Successfully ${item.brandSelected ? 'added' : 'removed'} ${formData.value.name} ${item.brandSelected ? 'to' : 'from'} ${item.shop.name}.` )
        }
    } catch (error) {
        console.error("Error: ", error);
    }
    console.log(item);
}

const isSelected = (item)=> {
    if(item.brandSelected){
        selectedShops.value.push(item);
    }else{
        if(selectedShops.value.find(s => s.shop.id !== item.shop.id)){
            selectedShops.value = selectedShops.value.filter(s => s.shop.id !== item.shop.id)
        }else{
            console.log("")
        }
    }
}


onMounted(() => {

});
</script>

<style>
.v-field--appended {
    padding-inline-end: 0px !important;
}

.v-col>.v-label,
.v-col>.v-checkbox .v-label {
    font-weight: 700;
    font-size: 14px;
    opacity: 1;
}

.shop-description-input textarea,
.shop-info-container .v-field__input {
    font-size: 14px !important;
    font-weight: 300 !important;
}

.emoji-picker-container {
    width: 300px;
    /* Adjust width as needed */
    height: 400px;
    /* Adjust height as needed */
    overflow-y: auto;
    /* Add scroll if content overflows */
    padding: 8px;
}

.date-picker .v-field .v-field__append-inner {
    background-color: rgb(var(--v-theme-default)) !important;
}

.time-input .v-field__input {
    padding-right: 0px;
}

.create-news-tabs .v-tab {
    font-weight: 600 !important;
}
</style>

<style scoped>
.v-tab-selected {
    border: 1px solid #ddd !important;
    border-bottom: 0 !important;
}

.v-window-item--active {
    border-top: 0 !important;
    border: 1px solid #ddd !important;
}
</style>
